define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/constants",
	"csi/xml",
	"csi/xml/Query",
	"csi/xml/Search",
], function(declare, csi, Controller, {FMT_ATTR_LIST}, xml, Query, Search) {

	return declare(Controller, {
		/** @property {Record<cnl, boolean>} _hashRequests - hash of nodes whose calendars are still being created */
		_hashRequests: null,

		/**
		 * @override
		 * Apply product type filters to view query
		 */
		applyActionFilters(view) {
			const {TrackingStyleTypes} = this.m_cache.get(this.getNode().Proto);
			const n = TrackingStyleTypes.length;
			const q = new Query();

			// filter out all nodes that already reference the calendar
			q.Not().RefAttr("Master", xml.OP_EQUALS, this.m_urlNode, "Child:Calendar");

			if (n == 1) {
				q.RefAttr("ProductType", xml.OP_EQUALS, TrackingStyleTypes[0]);
			} else if (n > 1) {
				const qOr = q.Or();

				TrackingStyleTypes.forEach((t) => {
					qOr.RefAttr("ProductType", xml.OP_EQUALS, t);
				});
			}

			view.relRoot.addQuery(q);

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Add dependency path to ProtoCalendar for logic above
		 */
		onDependencyPaths(paths) {
			paths.push("Child:Proto");
		},

		/**
		 * @override
		 * Add aggregate test to ensure we don't allow selecting nodes where the calendar is still in the process of being created
		 */
		onFormData(fd) {
			fd.m_fAggregateTest = (ctx, fd) => !this._hashRequests[ctx.getNodeURL()];
		},

		/**
		 * @override
		 * Find nodes whose calendars are still in the process of being created so we do not allow
		 * them to be selected again
		 */
		onPreActionDeferreds(dfds) {
			const search = new Search()
				.byType("CalendarRequest")
				.addParameter(FMT_ATTR_LIST, "CalendarRequest:ParentNode");

			search.getQuery()
				.RefAttr("RequestCalendar", xml.OP_EQUALS, this.m_urlNode)
				.Attr("RequestStatus", xml.OP_EQUALS, "Pending");

			dfds.push(search.execute().then((response) => {
				this._hashRequests = csi.hashArray(response.getResultNodes(), "ParentNode", Boolean);
			}));
		},

		/**
		 * @override
		 * Write operations to apply calendar to selected nodes
		 */
		toWriter() {
			const {m_urlNode, m_writer} = this;

			this.getFormData().getSelectedNodes().forEach((node) => {
				m_writer.callMethod("Apparel", "ApplyMasterCalendarToMaterials")
					.addParameter(xml.PROP_URL_FROM, xml.ATTR_REF, m_urlNode)
					.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, node.$URL)
			});
		}
	});
});